     
<template>
  <div class="bg4 fl">
    <h1>{{cardObj.name}} </h1>
    <div class="content">
      <div class="bg-yuan">
        <img
         :src="require('../../../assets/image/echarts/big_yuan.png')"
          alt="图片有误"
        >
        <h1>{{cardObj.data || "0"}}<span>分</span></h1>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cardObj: {
      type: Object,
      required: true,
      default: {
        name: "资源研发",
        data: "32",
      },
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.bg4 {
  width: 278px;
  height: 336px;
  background: url("../../../assets/image/echarts/bg3.png") no-repeat;
  margin-right: 20px;
  margin-bottom: 20px;
  h1 {
    height: 54px;
    line-height: 54px;
    font-size: 16px;
    font-weight: 500;
    padding-left: 15px;
  }
  .content {
    padding: 20px;
    position: relative;
    left: 0;
    top: 0;
    .bg-yuan {
      width: 245px;
      height: 245px;
    }
    h1 {
      position: absolute;
      transform: translate(-50%, -50%);
      top: 50%;
      left: 50%;
      font-size: 60px;
      font-weight: 500;
      color: #fff;
      span {
        font-size: 15px;
        padding-left: 10px;
      }
    }
  }
}
</style>

    